import {
  useQuery,
  useMutation,
  useQueryClient,
  noop
} from '@tanstack/react-query';
import * as networking from '../lib/networking';
import { RhinoContextType, RhinoRecordIdentifier } from '../index';

export const SESSIONS_PATH = '/api/auth/sessions';
export const sessionsQueryKey = ['sessions'];

export const useSessions = () =>
  useQuery({
    queryKey: sessionsQueryKey,
    queryFn: () =>
      networking.networkApiCallOnlyData(SESSIONS_PATH, { method: 'get' })
  });

// Prefetch from a TanStack Router loader so the sessions list is in the React
// Query cache before <Sessions> mounts. The key matches useSessions, so the
// component's useQuery deduplicates and renders without a loading spinner.
// (Collapses into prefetchModelIndex once Session is a Rhino resource — see
// TODO.md "Make Session a user-scoped Rhino resource".)
export const prefetchSessions = (rhino: RhinoContextType) =>
  rhino.queryClient
    .query({
      queryKey: sessionsQueryKey,
      queryFn: () =>
        networking.networkApiCallOnlyData(SESSIONS_PATH, { method: 'get' })
    })
    .then(noop, noop);

export const useRevokeSession = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: RhinoRecordIdentifier) =>
      networking.networkApiCallOnlyData(`${SESSIONS_PATH}/${id}`, {
        method: 'delete'
      }),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: sessionsQueryKey })
  });
};

export const useRevokeOtherSessions = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      networking.networkApiCallOnlyData(SESSIONS_PATH, { method: 'delete' }),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: sessionsQueryKey })
  });
};
